import mixpanel from "mixpanel-browser";
import { USER_ROLE_KEY, SOURCE_SESSION_KEY } from "../constants";
import { ChatReply } from "../graphql/types/graphql";

export enum MIX_PANEL_EVENTS {
  CHAT_APP_OPENED = "chat_app_opened",
  SIGN_UP = "sign_up",
  SIGN_IN = "sign_in",
  SUMMARY_SUBMITTED = "Summary submitted",
  SUMMARY_EDITED = "Summary edited",
  SUGGESTED_SELECTED = "Suggested question selected",
  ASKED_GENERAL_QUESTION = "Asked general question",
  QUESTION = "Question submitted",
  QUESTION_EDITED = "Question edited",
  ANSWER = "Answer provided",
  FEEDBACK = "Feedback submitted",
  NEW_CASE = "New Case clicked",
  REF_OPENED = "Reference opened",
  GUIDELINE_CHANGED = "Guideline changed",
  GUIDELINES_REQUESTED = "Requested organizational guidelines",
}

const SERVER_REPORTER =
  "https://3af323vq99.execute-api.us-east-1.amazonaws.com/dev/report";

export class MixPanelEventReporter {
  private currentUserName: string | undefined;
  private currentUserRole: string | undefined;
  private currentEnv: string | undefined;
  private currentSource: string | undefined;
  constructor(
    private token: string,
    private isConsent: boolean,
    private env: string,
  ) {
    mixpanel.init(token, {
      persistence: "localStorage",
      opt_out_tracking_by_default: !isConsent,
    });
    const queryParams = new URLSearchParams(window.location.search);
    const src =
      queryParams.get("src") || sessionStorage.getItem(SOURCE_SESSION_KEY);
    if (src && src !== sessionStorage.getItem(SOURCE_SESSION_KEY)) {
      sessionStorage.setItem(SOURCE_SESSION_KEY, src);
    } else if (!src) {
      sessionStorage.removeItem(SOURCE_SESSION_KEY);
    }
    this.currentUserRole = localStorage.getItem(USER_ROLE_KEY); //get user role from local storage for now
    this.currentEnv = env;
    this.currentSource = src;
  }

  public consent() {
    this.isConsent = true;
    mixpanel.opt_in_tracking();
    if (this.currentUserName) {
      this.onLogin(this.currentUserName, "");
    }
  }

  public setUserRole(role: string) {
    this.currentUserRole = role;
  }

  public onLogin(userName: string, userRole: string) {
    this.currentUserName = userName;
    if (this.isConsent) {
      mixpanel.people.set_once({
        $email: userName,
        "Sign up date": new Date(),
        "User role": userRole || this.currentUserRole,
      });
      mixpanel.identify(userName);
    }
  }

  public onLogout() {
    this.currentUserName = null;
    mixpanel.reset();
  }

  public reportEvent(eventId: string, props = {}) {
    if (this.isConsent) {
      if (this.currentEnv) {
        props["env"] = this.currentEnv;
      }
      mixpanel.track(eventId, {
        ...props,
        src: this.currentSource,
        userRole: this.currentUserRole,
      });
    }
  }

  public reportServerEvent(props = {}) {
    navigator.sendBeacon(
      SERVER_REPORTER,
      JSON.stringify({
        ...props,
        stage: process.env.REACT_APP_NODE_ENV,
        userId: this.currentUserName,
        date: new Date(),
        src: this.currentSource,
        userRole: this.currentUserRole,
      }),
    );
  }

  public reportAnswer(answer: ChatReply) {
    const props = {
      Guidelines: answer?.guidelines?.length || 0,
    };
    if (answer?.guidelines?.length)
      props["Guidelines used"] = answer.guidelines
        .map((g) => g.title + " (" + g.url + ")")
        .join(", ");

    this.reportEvent(MIX_PANEL_EVENTS.ANSWER, props);
  }
}
